// Matches IPv4 addresses (e.g. 192.168.1.1, 172.16.0.55)
const IPV4_RE = /^(\d{1,3}\.){3}\d{1,3}$/;

export function getSubdomain(hostname?: string | null): string {
  const host = (hostname || window.location.hostname || '').toLowerCase();

  if (!host || host === 'localhost' || host === '127.0.0.1' || host === 'donator-stem-outlast.ngrok-free.dev' || IPV4_RE.test(host)) {
    return '';
  }

  if (host.endsWith('.localhost')) {
    const parts = host.split('.');
    return parts.length > 1 ? parts[0] : '';
  }

  // Default Azure Static Apps domains are platform hostnames, not tenant subdomains.
  if (host.endsWith('.azurestaticapps.net')) {
    return '';
  }

  const parts = host.split('.').filter(Boolean);
  if (parts.length < 3) {
    return '';
  }

  return parts[0];
}
